import { render, staticRenderFns } from "./iconBtns.vue?vue&type=template&id=5f6deef1&scoped=true&"
import script from "./iconBtns.vue?vue&type=script&lang=js&"
export * from "./iconBtns.vue?vue&type=script&lang=js&"
import style0 from "./iconBtns.vue?vue&type=style&index=0&id=5f6deef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6deef1",
  null
  
)

export default component.exports